import { render, staticRenderFns } from "./Arrangements.vue?vue&type=template&id=cdeecc7c"
import script from "./Arrangements.vue?vue&type=script&lang=js"
export * from "./Arrangements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports